/* eslint-disable prefer-const */
import React from 'react';
import { useParams } from 'react-router';

import { useQuery } from '@apollo/client';
import { getComplaint, userByUserType } from '../graphql/queries';
import ComplaintManagementDetail from '../components/admin/ComplaintManagementDetail';
import DisplayLoading from '../components/common/DisplayLoading';
import DisplayError from '../components/common/DisplayError';

const AdminComplaintViewPage = () => {
  let { confirmationId } = useParams();

  const { data, error, loading } = useQuery(getComplaint, {
    variables: {
      confirmation: confirmationId,
      fetchPolicy: 'network-only'
    }
  });
  const {
    data: userList,
    error: userListError,
    loading: userListLoading
  } = useQuery(userByUserType, {
    variables: { userType: 'ADMIN' },
    fetchPolicy: 'network-only'
  });

  return (
    <>
      <DisplayLoading loadingMessage={loading && userListLoading} iconName="circle notched" />
      <DisplayError errorMessage={error} />
      <DisplayError errorMessage={userListError} />
      {data && data.getComplaint && (
        <ComplaintManagementDetail userList={userList} complaint={data.getComplaint} />
      )}
    </>
  );
};

export default AdminComplaintViewPage;
